import { gsap } from '../global/gsap';

const initSignupForm = (toggles) => {
    const body = document.querySelector('.js-body');
    const signupForm = document.querySelector('.js-signup-overlay');
    const signupHalf = document.querySelector('.js-signup-content');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'signup-active';
    let isActive = false;

    const overlayTl = gsap.timeline();

    gsap.set(signupForm, {
        opacity: 0,
    });

    gsap.set(signupHalf, {
        opacity: 0,
        yPercent: 25
    });

    overlayTl.to(signupForm, { opacity: 1, duration: 0.75 });
    overlayTl.to(signupHalf, { opacity: 1, yPercent: 0, stagger: 0.1, duration: 0.300 }, '-=.5');
    overlayTl.add(() => {
        if (isActive) {
            signupForm.style.pointerEvents = 'all';
        } else {
            signupForm.style.pointerEvents = 'none';
        }
    });

    overlayTl.pause();

    const toggleSignup = () => {
        isActive = !isActive;

        if (isActive) {
            body.classList.add(stopScrollingClass, isActiveClass);
            overlayTl.timeScale(1).play();
        } else {
            body.classList.remove(stopScrollingClass, isActiveClass);
            signupForm.style.pointerEvents = 'none';
            overlayTl.timeScale(2).reverse();
        }
    };

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            toggleSignup();
        });
    });

    // Open on load when the URL contains ?signup
    if (new URLSearchParams(window.location.search).has('signup')) {
        toggleSignup();
    }
};

export { initSignupForm as default };
